import { SINGLE_UPLOAD_PAYLOAD_UPDATE_SUCCESS, SINGLE_UPLOAD_PAYLOAD_CLEAR } from "constants/actionTypes";

interface SingleUploadState {
  payload: any;
  isLoading: boolean;
  error: string | null;
}

const initialState: SingleUploadState = {
  payload: {},
  isLoading: false,
  error: null,
};

interface Action {
  type: string;
  payload?: any;
}

export function singleUpload(state = initialState, action: Action): SingleUploadState {
  const { type, payload } = action;

  switch (type) {
    case SINGLE_UPLOAD_PAYLOAD_UPDATE_SUCCESS:
      return {
        ...state,
        payload: payload || {}, // Ensure payload is not undefined
        isLoading: false,
        error: null,
      };
    case SINGLE_UPLOAD_PAYLOAD_CLEAR:
      return {
        ...state,
        payload: {}, // Clear the payload
        isLoading: false,
        error: null,
      }; // Reset to initial state
    

    default:
      return state;
  }
}